import React from "react";
import { toast as sonner } from "sonner";

import { Icons } from "./icons";

interface ToastProps {
  type: "success" | "warn" | "error" | "loading";
  message: string | React.ReactNode;
  description?: string;
  duration?: number;
  closeButton?: boolean;
}

export const toast = ({
  type,
  message,
  description,
  duration = 5000,
  closeButton = true,
}: ToastProps) => {
  let icon: React.ReactNode;
  let style: React.CSSProperties;

  switch (type) {
    case "success":
      icon = <Icons.CircleCheckFill className="w-4 h-4" />;
      style = { background: "#0195c5", color: "#ffffff" };
      break;
    case "warn":
      icon = <Icons.WarnFill className="w-4 h-4" />;
      style = { background: "#ffc66f", color: "#ffffff" };
      break;
    case "error":
      icon = <Icons.AlertCircleFill className="w-4 h-4" />;
      style = { background: "#ef8262", color: "#ffffff" };
      break;
    case "loading":
      icon = <Icons.Spinner className="w-4 h-4 animate-spin" />;
      style = { background: "#0195c5", color: "#ffffff" };
      duration = Infinity;
      break;
    default:
      icon = <Icons.Check className="w-4 h-4" />;
      style = { background: "#0195c5", color: "#ffffff" };
  }

  sonner(message, {
    description,
    style,
    icon,
    duration,
    closeButton,
  });
};
